import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextFTO } from "./TextFTO";
import { ImageFTO } from "./ImageFTO";
import { SourcesFTO } from "./SourcesFTO";


export default function Dia_FTO() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
    <Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
           <TextCard 
            textcard={'FTO (Fat Gene)'  }
           />
    </Button>

    <CustomDialog open={open} onClose={handleClose}

        title='FAT Gene - Variants'

        content={<TextFTO />}

        image={ <ImageFTO />}

        sources={<SourcesFTO />}

    />
</>
)}